// extracted by mini-css-extract-plugin
export default {"sectionStyleForm":"SectionStyleForm_sectionStyleForm__YqJdg"};